import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

import { VersionsService } from '@core/services/versions/versions.service';
import { AnnotationsService } from '@core/services/annotations/annotations.service';
import { UrlService } from '@core/services/url/url.service';
import { NotificationsService } from '@core/services/notifications/notifications.service';

import * as Objects from '@core/objects';
import { FilesListItemMenuClick } from '@core/components/files/lists/files-list-item-menu-click';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { NotificationsContextEnum } from '@core/store/models/notifications.enum';


@Component({
    selector: 'plugin-share-feedback-core-version-files',
    templateUrl: './version-files.component.html',
    styleUrls: ['./version-files.component.scss']
})
export class PluginShareFeedbackCoreVersionFilesComponent implements OnInit, OnChanges {

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_FOUND = 3;

    @Input() version: Objects.Version = null;
    @Input() user: Objects.User = null;
    @Input() canCreateNotes: boolean = true;
    @Input() prefixUrl: string = '';
    @Input() context: string; //for files to display menu signature only

    public readonly MODAL_VIEW_NONE = 0;
    public readonly MODAL_VIEW_FILES_SIGNED_ERROR = 1

    public modalView: number = this.MODAL_VIEW_NONE;
    public files: Array<Objects.File> = [];
    public selectedFile: Objects.File = null;
    public status: number = this.STATUS_LOADING;
    public notesCounter:  Array<Objects.AnnotationsCounter>;
    
    public menu: Array<ThreeDotsMenuItem> = [
        {
            title: "Download File",
            key: "download",
            icon: "download",
            order: 1
        },
        {
            title: "Open Preview in New Tab",
            key: "open-preview",
            icon: "see-details",
            order: 2
        },
    ];


    constructor(private versionsSrv: VersionsService,
        private urlSrv: UrlService,    
        private notifSrv: NotificationsService,   
        private annotationsSrv: AnnotationsService ) { }

    ngOnInit() {}

    ngOnChanges(changes: SimpleChanges) {
        if(changes.version && this.version != null)
            this.init();
    }

    onMenuClick(menu: FilesListItemMenuClick) {
        // console.debug(" clic on item ",menu.key);
        switch(menu.key) {
            case "download-comments": 
                // manage here the download with comments starting notification action to download it..
                this.notifSrv.addNotification(NotificationsContextEnum.EVENT_FILE_ANNOTATIONS_START, {id: this.version.id, details: { url: "/versions/"+this.version.id, file: menu.file}});
                break;
            case "download":
                // console.debug(" download click on file ", menu.file)
                window.location.href = this.urlSrv.build('/files/'+menu.file.id);
                break;
            case "open-preview":
                // console.debug(" open-preview click on file ", menu.file)
                window.open(window.location.href +'/files/'+menu.file.id, '_blank');
                break;
            case "download-signatures":
                // start notification to download compressed project files in zip
                this.versionsSrv.getFileWithSignatures$(this.version,menu.file)
                    .subscribe({
                        next: (fileSigned: Objects.File) => {
                            window.location.href = this.urlSrv.build('/files/'+fileSigned.id);
                        },
                        error: (error) => {
                            this.modalView = this.MODAL_VIEW_FILES_SIGNED_ERROR;
                        }
                    })
                break;
        }
    }

    actionFileClick(file: Objects.File){
        // This navigates to new route from the current route.
        // this.router.navigate(["files/"+file.id], { relativeTo: this.activatedRoute });
    }
    
    onActionDownloadClick(file: Objects.File){
        window.location.href = this.urlSrv.build('/files/'+file.id);
    }

    protected init() {
        this.status = this.STATUS_LOADING;
        this.selectedFile = null;
        // prefix to get files notes
        this.prefixUrl = "/versions/" + this.version.id;
        this.loadFiles();

    }
    protected loadFiles(){
        this.versionsSrv.getFiles$(this.version).subscribe((files: Array<Objects.File>) => {
            this.files = files;
            if (files != null){
                this.loadAnnotationsCounter();
            }
        });
    }

    protected loadAnnotationsCounter() {
        this.annotationsSrv.getCounter(this.prefixUrl).subscribe({
            next: (counter: Objects.AnnotationsCounter[]) => {
                this.notesCounter = counter;
                // this.loadingCounter = false;
                this.status = this.STATUS_DONE;
            },
            error: (error: HttpErrorResponse) => {
                console.debug(" ERROR getting message notes counter:",error);
                this.notesCounter = [];
                // this.loadingCounter = false;
                this.status = this.STATUS_DONE;
            }
        })
    }

    public openNotes(e: any){
        if(this.selectedFile != null && this.selectedFile.id == e.id)
            this.selectedFile = null;
        else
            this.selectedFile = e;
    }

    onSavedAnnotations(e:any) {
        this.loadAnnotationsCounter();
    }

    public dismmisError(){
        this.modalView = this.MODAL_VIEW_NONE;
    }


}
